import tippy from 'tippy.js'
import 'tippy.js/animations/shift-away.css'
import 'tippy.js/themes/light.css'

export default {
  setup() {
    const el = this.el
    el.addEventListener('click', (event) => {
      // here we stop the click of the dropdown from triggering _other_ click handlers.  This is mainly targeted at the redirect_click
      // of a data table when the dropdown is embedded within the row
      event.stopPropagation()
    })
    this.dropdown = tippy(el, {
      allowHTML: true,
      interactive: true,
      trigger: 'click',
      theme: 'light',
      // doing this resolves overflow problems
      // source: https://stackoverflow.com/a/62554812
      appendTo: document.body,
      animation: 'shift-away',
      maxWidth: 'none',
      arrow: false,
      placement: this.el.dataset.placement,
      content(_reference) {
        // Note:  Tippy uses the actual element here and sets the style back to block (it defaults to hidden)
        // This means that IF liveview re-renders the page, the content will be automatically hidden again.
        const template = document.getElementById(`${el.id}-content`)
        template.style.display = 'block'
        return template
      },
      onShown(instance) {
        document
          .querySelector('[data-tippy-root]')
          .addEventListener('click', (_event) => {
            instance.hide()
          })
      }
    })
  },
  destroy() {
    this.dropdown?.destroy()
    this.dropdown = null
  },
  mounted() {
    this.setup()
  },
  updated() {
    // when the underlying DOM has been updated by LV, reset the content
    // otherwise tippy still thinks content is same as when initially mounted
    const el = this.el
    const template = document.getElementById(`${el.id}-content`)
    this.dropdown.setContent(template.innerHTML)
  },
  destroyed() {
    this.destroy()
  }
}
